var $ = require ('jquery');
var template = require('../templates/fail.hbs');


/**
 * Execute a sequence of promise factories.
 * @param  {Array} promiseFactories Array of promise factory functions.
 * @return {Promise}                  A resolved promise.
 */
function execute(promiseFactories) {
  var result = Promise.resolve();
  promiseFactories.forEach(function (promiseFactory) {
    result = result.then(promiseFactory);
  });
  return result;
}


/**
 * Creates a fail view with a rewind video and UI.
 * @param  {Object} video   An instance of video-promise.
 * @param  {Object} options Options hash
 * @return {Function}         Promise factory.
 */
var failFactory = function (video, options) {
  var defaults = {
    wrapper: "#appendHere",
    uiclasses: {
      frame: "",
      number: ""
    }
  };

  defaults = Object.assign(defaults, options);

  var $wrapper = $(defaults.wrapper);
  var html = template(defaults.uiclasses);

  /**
   * Displays rendered template.
   * @return {Promise} Resolves on user click.
   */
  var displayFailView = function () {
    $wrapper.html(html);
    setTimeout(function () {
      $wrapper.addClass('in');
    }, 250);
    return new Promise(function (resolve, reject) {
      $wrapper.on('click', '#retry', function() {
        $wrapper.html('')
          .removeClass('in')
          .off('click', '#retry');
        resolve();
      });
    });
  };

  var promises = [displayFailView, video.start];

  return function () {
    return Promise.resolve()
      .then(function () {
        return execute(promises);
      })
      .catch(console.log.bind(console));
  };

};

module.exports = failFactory;
